module.exports = __webpack_public_path__ + "static/media/co.ed07e7f3.svg";